export const MAIN_CLASS_NAME = 'toolset-list';
export const LIST_CLASS_NAME = `${MAIN_CLASS_NAME}__list`;
export const PAGINATION_ROW_CLASS_NAME = `${MAIN_CLASS_NAME}__pagination-row`;

export const SKELETON_ROW_COUNT = 4;
export const SKELETON_HEIGHT = 56;
export const SKELETON_BORDER_RADIUS = 16;
